module.exports = __webpack_public_path__ + "assets/img/card_ifcic.5d41de18.jpg";